import PropTypes from 'prop-types';

/* PropTypes */

export const TablePropTypes = {
  data: PropTypes.object,
  gridColumns: PropTypes.func,
  loading: PropTypes.bool,
  name: PropTypes.string,
  onPageChanged: PropTypes.func,
  refetch: PropTypes.func,
  title: PropTypes.string,
  totalCount: PropTypes.number,
  variables: PropTypes.object,
  order: PropTypes.string,
  showColumnSettings: PropTypes.bool,
  hideDeletedButton: PropTypes.bool,
};

/* Default Props */

export const TableDefaultProps = {
  gridColumns: null,
  loading: false,
  name: null,
  onPageChanged: null,
  refetch: () => {},
  title: null,
  totalCount: 0,
  variables: {},
  hideDeletedButton: false,
};
